import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import {SubTypeProductService} from "../../services/sub-type-product.service";
import {first} from "rxjs/operators";

declare var swal: any;

@Component({
  selector: 'app-brand-sub-type-products',
  templateUrl: './brand-sub-type-products.component.html',
  styleUrls: ['./brand-sub-type-products.component.scss']
})
export class BrandSubTypeProductsComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    sub_type_products: any[];
    @ViewChild(DataTableDirective) private dtElement;

    constructor(
        private subTypeProductService: SubTypeProductService,
    ) { }

    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.subTypeProductService.getDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.sub_type_products = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'name'},
            ]
        };
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    delete(item: any): void {
        swal.fire({
            title: '¿Estás seguro que deseas eliminar este registro?',
            showCancelButton: true,
            confirmButtonText: 'Si, elimínalo!',
            showLoaderOnConfirm: true,
            preConfirm: (arg) => {
                return this.subTypeProductService.delete(item.id)
                    .pipe(first())
                    .subscribe(response => {
                        swal.fire({
                            title: 'Elemento eliminado con éxito',
                            type: 'success'
                        });
                        this.reloadTable();
                    }, error => {
                        swal.fire({
                            title: error,
                            type: 'error'
                        });
                        return error;
                    });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
        });
    }
}
